/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import LocationMarker from '@components/LocationMarker';
import configs from '@configs';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import {
  CircularProgress,
  TextField, Button, Card, CardContent,
} from '@material-ui/core';
import ImagePicker from '@components/ImagePicker';
import useHook from './hook';

const id_prefix = 'uploaded_image';
const is_inline = configs.preview_mode === 'inline';

export default () => {
  const { t } = useTranslation();
  const h = useHook();

  const is_show_inputs = h.images?.length > 0;

  const onMetadata = metadata => {
    h.set_aperture(metadata.aperture);
    h.set_telescope_focal_length(metadata['focal length']);
    h.set_iso(metadata['focal length']);
    h.set_camera_model(metadata.camera);
    h.set_shutter_speed(metadata.shutter);
    h.set_datetime(moment(metadata.timestamp));
  };

  useEffect(() => {
    if (is_inline) {
      h.images.map((_, index) => {
        setTimeout(() => {
          const src = cv.imread(id_prefix + 0);
          // const src = cv.imdecode(URL.createObjectURL(images[0]));
          const dst = new cv.Mat();
          cv.cvtColor(src, src, cv.COLOR_RGBA2GRAY, 0);
          cv.equalizeHist(src, dst);
          cv.imshow(id_prefix + index + 'histogram', dst);
          src.delete();
          dst.delete();
        }, 1500);
        setTimeout(() => {
          const src = cv.imread(id_prefix + 0);
          const dst = new cv.Mat();
          // cv.cvtColor(src, src, cv.COLOR_RGB2GRAY, 0);
          // You can try more different parameters
          cv.Canny(src, dst, 50, 100, 3, false);
          cv.imshow(id_prefix + index + 'canny', dst);
          src.delete();
          dst.delete();
        }, 1500);
      });
    }
  }, [h.images]);

  return (
    <>
      <div className="space-children-vertical">
        <ImagePicker images={h.images} set_images={h.set_images} id_prefix={id_prefix} onMetadata={onMetadata} />
        {is_inline && <div>
          {h.images.map((_, index) => (
            <>
              <div className="col-md-4 col-sm-12 mb-2 mt-2">
                <div>Histogram Equalization</div>
                <canvas id={id_prefix + index + 'histogram'} />
              </div>
              <div className="col-md-4 col-sm-12 mb-2 mt-2">
                <div>Canny Edge</div>
                <canvas id={id_prefix + index + 'canny'} />
              </div>
            </>
          ))}
        </div>}
        {is_show_inputs && (
          <TextField
            multiline
            rows={3}
            value={h.description}
            onChange={e => h.set_description(e.target.value)}
            variant="outlined"
            label="Description"
            fullWidth
          />
        )}

        {is_show_inputs && (
          <>
            <div className="row space-children-vertical">
              <div className="col-md-6 col-sm-12">
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDateTimePicker
                    disableFuture
                    required
                    ampm={false}
                    disableToolbar
                    animateYearScrolling
                    // variant="static"
                    autoOk
                    inputVariant="outlined"
                    // variant="inline"
                    format="D MMM YYYY hh:mm a"
                    // views="minutes"
                    margin="normal"
                    label="Recorded At"
                    value={h.datetime}
                    onChange={h.set_datetime}
                    KeyboardButtonProps={{ 'aria-label': 'change date' }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div className="col-md-6 col-sm-12">
                <TextField
                  value={h.hijri_date}
                  onChange={e => h.set_hijri_date(e.target.value)}
                  variant="outlined"
                  label="Hijri Date"
                  fullWidth
                />
              </div>
            </div>
            <div className="row space-children-vertical">
              <div className="col-md-6 col-sm-12">
                <Card>
                  <CardContent>
                    <div className="space-children-vertical">
                      <div className="text-muted">Telescope</div>
                      <TextField
                        value={h.telescope_model}
                        onChange={e => h.set_telescope_model(e.target.value)}
                        variant="outlined"
                        label="Model"
                        fullWidth
                      />
                      <TextField
                        value={h.telescope_focal_length}
                        onChange={e => h.set_telescope_focal_length(e.target.value)}
                        variant="outlined"
                        label="Focal Length"
                        fullWidth
                      />
                      <TextField
                        value={h.telescope_aperture}
                        onChange={e => h.set_telescope_aperture(e.target.value)}
                        variant="outlined"
                        label="Aperture"
                        fullWidth
                      />
                    </div>
                  </CardContent>
                </Card>
              </div>
              <div className="col-md-6 col-sm-12">
                <Card>
                  <CardContent>
                    <div className="space-children-vertical">
                      <div className="text-muted">Camera</div>
                      <TextField
                        value={h.camera_model}
                        onChange={e => h.set_camera_model(e.target.value)}
                        variant="outlined"
                        label="Model"
                        fullWidth
                      />
                      <TextField
                        value={h.camera_resolution}
                        onChange={e => h.set_camera_resolution(e.target.value)}
                        variant="outlined"
                        label="Resolution"
                        fullWidth
                      />
                      <TextField
                        value={h.camera_pixel}
                        onChange={e => h.set_camera_pixel(e.target.value)}
                        variant="outlined"
                        label="Pixel"
                        fullWidth
                      />
                    </div>
                  </CardContent>
                </Card>
              </div>
              <div className="col-md-6 col-sm-12">
                <Card>
                  <CardContent>
                    <div className="space-children-vertical">
                      <TextField
                        value={h.barlow}
                        onChange={e => h.set_barlow(e.target.value)}
                        variant="outlined"
                        label="Barlow"
                        fullWidth
                      />
                      <TextField value={h.iso} onChange={e => h.set_iso(e.target.value)} variant="outlined" label="ISO" fullWidth />
                      <TextField
                        value={h.shutter_speed}
                        onChange={e => h.set_shutter_speed(e.target.value)}
                        variant="outlined"
                        label="Shutter Speed"
                        fullWidth
                      />
                      <TextField
                        value={h.aperture}
                        onChange={e => h.set_aperture(e.target.value)}
                        variant="outlined"
                        label="Aperture"
                        fullWidth
                      />
                    </div>
                  </CardContent>
                </Card>
              </div>
              <div className="col-md-6 col-sm-12">
                <Card>
                  <CardContent>
                    <div className="space-children-vertical">
                      <LocationMarker onConfirmDraw={h.onConfirmDraw} mode="select_coordinate" />
                      <TextField
                        type="number"
                        value={h.latitude}
                        onChange={e => h.set_latitude(e.target.value)}
                        variant="outlined"
                        label="Latitude"
                        fullWidth
                      />
                      <TextField
                        type="number"
                        value={h.longitude}
                        onChange={e => h.set_longitude(e.target.value)}
                        variant="outlined"
                        label="Longitude"
                        fullWidth
                      />
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
            <div className="all-center pt-5">
              {h.is_loading
                ? <CircularProgress size={25} />
                : (
                  <Button
                    className="background-secondary"
                    variant="contained"
                    children={t('common.save')}
                    onClick={h.submit}
                  />
                )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
